export const inputPattern = (decimalPlaces: number) =>
  new RegExp(`^\\d+${decimalPlaces > 0 ? `\\.?\\d{0,${decimalPlaces}}` : ''}$`);
